"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmLabel = void 0;
/* eslint-disable react/require-default-props */
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
function SmLabel({ label = '', labelIcon = '' }) {
    if (!label)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("label", { className: "c-field__label" },
        label,
        labelIcon && typeof labelIcon === 'string' ? (react_1.default.createElement(Icon_1.SmIcon, { "data-testid": "sm-icon", name: labelIcon, type: "outlined", size: "small" })) : (react_1.default.createElement(react_1.default.Fragment, null, labelIcon))));
}
exports.SmLabel = SmLabel;
//# sourceMappingURL=label.js.map